import React from 'react';

import * as OrganizationActions from 'actions/OrganizationActions';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {Routine} from 'constants/UserConstants';
import {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {EntityWithText} from 'ui-library/entity-input/EntityInputConstants';
import {UserSearchType} from 'ui-library/entity-input/EntityInputWithSearch';
import {SingleEntityInput} from 'ui-library/entity-input/SingleEntityInput';
import {TagsInputSize} from 'ui-library/tags-input/TagsInputConstants';
import {isEnterKey} from 'util/Keyboard';

import * as OrganizationConstants from './OrganizationConstants';

interface Props {
  organizationId: string;
  organizationMembers: Array<OrganizationConstants.Member> | null;
}

/**
 * Input to search for Agents to add to the organization.
 */
export default function AddAgentInput(props: Props): JSX.Element {
  function handleSubmit({entity}: {entity?: Routine}): void {
    if (entity?.type === ModelTypeConstants.ROUTINE) {
      OrganizationActions.addMember(props.organizationId, entity);
    }
  }

  function filterMembersAndAgents(text: string, options: Array<EntityWithText>): Array<EntityWithText> {
    options = options.filter((o) => o.type === ModelTypeConstants.ROUTINE);
    if (!props.organizationMembers) {
      return options;
    }
    const existingMemberIds = props.organizationMembers.map((m) => m.id);
    return options.filter((o) => !existingMemberIds.includes(o.id));
  }

  return (
    <SingleEntityInput
      addPredicate={isEnterKey}
      allowEmails={false}
      allowTeams={false}
      allowOrganizations={false}
      allowBenchlingApps={false}
      allowAgents={true}
      buttonProps={{
        buttonStyle: ButtonStyle.SECONDARY,
        size: ButtonSize.SMALL,
        text: 'Add Agent',
      }}
      filterOptions={filterMembersAndAgents}
      onSubmit={handleSubmit}
      size={TagsInputSize.SMALL}
      placeholder="Search for an agent"
      userSearchType={UserSearchType.None}
    />
  );
}
